import AboutIcon from '@mui/icons-material/Dashboard';
import AboutList from './AboutList';

const resource = {
    list: AboutList,
    icon: AboutIcon,
    options: { label: 'About' }
};

export default resource;
